import { Flex, Tabs, type TabsProps } from 'antd';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './filters.module.scss';
import type { ManagerTimerState } from './types';
import type { Filter } from '@shared/ui/filters/lib/types';
import { InfinitySelectorChannels } from '@shared/ui/selector/infinity-select/infinity-select';
import { normalizeOptions } from '@shared/ui/filters/ui/filters/utils/normalize-options';

interface DialogsFiltersProps {
  dialogsSearchValue: string;
  insideDialogSearchValue?: string;
  dialogsSearchHandle: (value: string) => void;
  insideDialogSearchHandle?: (value: string) => void;
  managerTimer?: ManagerTimerState;
  value?: Filter[];
  activeTab?: 'total' | 'leads';
  onTabChange?: (next: 'total' | 'leads') => void;
  onSetFiltersFromValue?: (value: Filter[]) => void;
}

export const DialogsFilters: FC<DialogsFiltersProps> = ({
  value,
  activeTab = 'total',
  onTabChange,
  onSetFiltersFromValue,
}) => {
  const { t } = useTranslation('translation', { keyPrefix: 'dialogs' });
  const { t: tCommon } = useTranslation('translation');
  const channelFilter = value?.find((filter) => filter.type === 'channels');
  const channelValues = channelFilter?.option?.map((option) => option.value);

  const handleChannelChange = (_: unknown, option?: unknown) => {
    const normalized = normalizeOptions(option);
    const nextFilters = (value ?? []).filter((filter) => filter.type !== 'channels');

    if (normalized.length) {
      nextFilters.push({ type: 'channels', option: normalized });
    }

    onSetFiltersFromValue?.(nextFilters);
  };

  const dialogTabs: TabsProps['items'] = [
    { key: 'total', label: t('tabs.all') },
    { key: 'leads', label: t('tabs.leads') },
  ];

  return (
    <Flex align="center" className={styles.root}>
      <Flex align="center" justify="space-between" className={styles.input__wrapper} gap={8}>
        <Tabs
          activeKey={activeTab}
          items={dialogTabs}
          onChange={(key) => onTabChange?.(key as 'total' | 'leads')}
        />

        <InfinitySelectorChannels
          className={styles.selector}
          selectMode="multiple"
          showSearch={false}
          placeholder={tCommon('common.filters.config.channelPlaceholder')}
          value={channelValues}
          onChange={handleChannelChange}
        />
      </Flex>
    </Flex>
  );
};
